import { defineActions } from "direct-vuex";

export enum ActionsTypes {
  FETCH_SERVICES = "fetchServices"
}

export const actions = defineActions({});
